"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const listSiteTabsUseCase_1 = __importDefault(require("@/useCases/evaluators/listSiteTabsUseCase"));
const index_view_1 = __importDefault(require("./index.view"));
function WorkFlowAlert() {
    const dispatch = (0, react_redux_1.useDispatch)();
    react_1.default.useEffect(() => {
        (0, listSiteTabsUseCase_1.default)()(dispatch);
    }, []);
    return (react_1.default.createElement(index_view_1.default, null));
}
exports.default = WorkFlowAlert;
